import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

import { Amplify } from 'aws-amplify';
import amplifyConfig from '../amplify_outputs.json';
import { installConsoleBuffer } from './utils/consoleBuffer';

// #328 — capture last 30 console.error/.warn calls so the Feedback
// widget can attach a recap to bug submissions. Install once, before
// anything else mounts, so we catch boot-time errors too.
installConsoleBuffer();

// Configure Amplify with production config
try {
  Amplify.configure(amplifyConfig);
  // Expose config so services can synchronously resolve endpoints (#310)
  window.__AMPLIFY_OUTPUTS__ = amplifyConfig;
  console.info('Amplify configured successfully');
} catch (error) {
  console.error('Amplify configuration failed:', error);
  console.info('Auth features will not work. Check amplify_outputs.json exists.');
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
); 